import React from 'react';

const Done = React.memo((props) => {
    return (
        <div className="done-container">
            <div className="check"><i class="fas fa-clipboard-check"></i></div>
            <h5>Done!</h5>
            <div className="message">
                Your order has been created successfully with the <b>Order #{props.orderId}</b>!
                <br />
                An email has been sent to you with the details of your order.
            </div>
        </div>
    );
});

Done.propTypes = {

}

export default Done;
